import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cpuinfo"
    }}>{`CPUInfo`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "emulationmode"
    }}>{`emulationMode`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`emulationMode`}</strong>{`: `}<inlineCode parentName="p">{`"rosetta2"`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "frequencymhz"
    }}>{`frequencyMhz`}</h3>
    <p>{`• `}<strong parentName="p">{`frequencyMhz`}</strong>{`: `}<em parentName="p">{`number`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "logicalcores"
    }}>{`logicalCores`}</h3>
    <p>{`• `}<strong parentName="p">{`logicalCores`}</strong>{`: `}<em parentName="p">{`number`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "physicalcores"
    }}>{`physicalCores`}</h3>
    <p>{`• `}<strong parentName="p">{`physicalCores`}</strong>{`: `}<em parentName="p">{`number`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "vendor"
    }}>{`vendor`}</h3>
    <p>{`• `}<strong parentName="p">{`vendor`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/modules/coremodules/#cpuvendorkind"
      }}><em parentName="a">{`CPUVendorKind`}</em></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      